module.exports = __webpack_public_path__ + "img/13.31826026.svg";